import { render, staticRenderFns } from "./KeywordSuggestionEditForm.vue?vue&type=template&id=18945c60"
import script from "./KeywordSuggestionEditForm.vue?vue&type=script&lang=js"
export * from "./KeywordSuggestionEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports